module.exports = __webpack_public_path__ + "static/img/ufooo.08fbe5d7.png";